<template>

    <div>

        <div class="flex items-center font-medium">
            <EnvelopeIcon class="h-5 w-5 mr-2" /> <span>Email notifications</span>
        </div>

        <div class="flex mt-4">
            <a href="#" @click.prevent.stop="toggle('inapp')" class="flex flex-row flex-grow">
                <div class="flex flex-grow">
                    Send an email to <span class="font-bold mx-1">{{ email }}</span> when a customer records a video
                    from Birdie web sdk
                </div>
                <div class="flex">
                    <toggle :checked="is_enabled_inapp" @click.prevent.stop @update="toggleCheckedInapp"></toggle>
                </div>
            </a>
        </div>

        <div class="flex mt-4">
            <a href="#" @click.prevent.stop="toggle('link')" class="flex flex-row flex-grow">
                <div class="flex flex-grow">
                    Send an email to <span class="font-bold mx-1">{{ email }}</span> when a customer records a video
                    using your {{ app_name }}-Link
                </div>
                <div class="flex">
                    <toggle :checked="is_enabled_link" @click.prevent.stop @update="toggleCheckedLink"></toggle>
                </div>
            </a>
        </div>

    </div>

</template>

<script>

import Toggle from '@/Components/UI/Toggle'
import { EnvelopeIcon } from "@heroicons/vue/24/outline";


export default {

    props: ['email', 'type', 'inapp', 'link'],

    components: {
        Toggle, EnvelopeIcon
    },

    created: function () {
        //console.log("enabled",this.enabled)
        this.is_enabled_inapp = this.inapp == "yes"
        this.is_enabled_link = this.link == "yes"
    },

    data() {
        return {
            is_enabled_inapp: false,
            is_enabled_link: false,
            app_name: this.$page.props.app_name
        }
    },

    mounted: function () {
    },

    methods: {
        toggleCheckedLink: function (checked) {
            //console.log("toggleCheckedLink", checked)
            this.is_enabled_link = checked
            this.updateTrigger("link")
        },
        toggleCheckedInapp: function (checked) {
            //console.log("toggleCheckedInapp", checked)
            this.is_enabled_inapp = checked
            this.updateTrigger("inapp")
        },
        toggle: function (type) {
            if (type == "link") {
                this.is_enabled_link = !this.is_enabled_link;
            }
            else if (type == "inapp") {
                this.is_enabled_inapp = !this.is_enabled_inapp;
            }
            //console.log(this.is_enabled_inapp)
            this.updateTrigger(type);
        },
        updateTrigger: function (type) {
            let url = this.$page.props.api_url + '/v1/user/set_meta';
            var meta_name = "notify_inapp_video_received";
            var meta_value = this.is_enabled_inapp ? "yes" : "no";
            if (type == "link") {
                meta_name = "notify_link_used";
                meta_value = this.is_enabled_link ? "yes" : "no";
            }
            var params = {
                meta: meta_name,
                value: meta_value
            };
            axios.post(url, params)
                .then(response => {
                    //console.log(response.data);
                    let options = {
                        type: "default",
                        timeout: 2500,
                        position: "top-right",
                        hideProgressBar: false,
                    }
                    this.$moshaToast("Setting updated", options)
                })
                .catch(e => {
                    console.error(e);
                });
        }
    },

    computed: {
        // enabled: {
        // 	get: function() {
        // 		return this.is_enabled == "yes"
        // 	},
        // 	set: function(newValue) {
        // 		// do nothing
        // 	}
        // }
    }
}

//   /user/set_meta', 'UserController@set_meta

</script>

<style scoped></style>
